import React from "react";
import Badge, { BadgeProps } from "../../../theme/badge/Badge";

export default function RequestType({ requestType, variant }: {
    requestType?: string,
    variant?: BadgeProps["variant"]
}) {
    return (
        <Badge variant={variant} title={`Request Type: ${requestType}`}>
            {requestType}
        </Badge>
    );
}

RequestType.defaultProps = {
    variant: "gray",
    requestType: "",
};
